import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralDropdownsTriggersTriggerPowerSelectDeleteSignature {
  Args: {};
}

const GeneralDropdownsTriggersTriggerPowerSelectDelete = <template>
  <button class="button--unstyled settings-report-cta__button" type="button">
    <PrismIcon @name="bin" @size="extra-small" />
  </button>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerPowerSelectDeleteSignature>;

export default GeneralDropdownsTriggersTriggerPowerSelectDelete;
